var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 28",
    d: "M80 40A40 40 0 1 1 40 0a40 40 0 0 1 40 40z",
    style: {
      fill: "#e7f6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9453",
    d: "M50 32.922v24.4a2.835 2.835 0 0 1-2.834 2.834H2.834A2.836 2.836 0 0 1 0 57.327v-24.4A2.822 2.822 0 0 1 .852 30.9h48.3A2.821 2.821 0 0 1 50 32.922z",
    transform: "translate(14.999 2.119)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9454",
    d: "M84.12 72.088a2.822 2.822 0 0 1-1.067 1.066L68.525 58.647a.754.754 0 1 1 1.066-1.067z",
    transform: "translate(-19.49 -11.242)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9455",
    d: "M16.343 58.647 1.815 73.154a2.822 2.822 0 0 1-1.067-1.066l14.529-14.509a.754.754 0 1 1 1.066 1.067z",
    transform: "translate(14.621 -11.242)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9457",
    d: "m50.018 30.072-20.3 19.29a5.585 5.585 0 0 1-7.694 0l-20.3-19.29a2.821 2.821 0 0 1 1.976-.809h44.336a2.821 2.821 0 0 1 1.982.809z",
    transform: "translate(14.13 2.944)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9463",
    d: "m48.666 12.628-1.933-2.667.343-3.275a.415.415 0 0 0-.244-.423l-3.01-1.339-1.339-3.01a.418.418 0 0 0-.423-.244l-3.276.342L36.118.079a.415.415 0 0 0-.487 0l-2.668 1.933-3.276-.342a.421.421 0 0 0-.423.244l-1.338 3.009-3.01 1.34a.415.415 0 0 0-.244.422l.342 3.276-1.933 2.667a.415.415 0 0 0 0 .487l1.933 2.667-.342 3.276a.415.415 0 0 0 .244.423l3.009 1.339 1.339 3.009a.42.42 0 0 0 .423.244l3.276-.343 2.667 1.933a.415.415 0 0 0 .487 0l2.667-1.933 3.276.343a.418.418 0 0 0 .423-.244l1.339-3.009 3.009-1.339a.416.416 0 0 0 .244-.422l-.343-3.276 1.933-2.667a.415.415 0 0 0 .001-.488z",
    transform: "translate(3.385 17.72)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9462",
    d: "M48.692 15.563a.694.694 0 0 0-.694.694v1.115a5.352 5.352 0 1 0 .562 3.928.694.694 0 1 0-1.35-.325A3.961 3.961 0 0 1 43.354 24a3.966 3.966 0 1 1 3.511-5.812H46.1a.694.694 0 1 0 0 1.388h2.594a.694.694 0 0 0 .694-.694v-2.63a.694.694 0 0 0-.696-.689z",
    transform: "translate(-4.188 10.305)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSent);
export default __webpack_public_path__ + "static/media/link-sent.820900c96954c73a52e748c9d9438fe8.svg";
export { ForwardRef as ReactComponent };